import { Shrine } from '@a4b/api/src/modules/Temple/types'
import { CARD_TYPES } from '../constants'

export const transformCardContentsResponse = (response: any): Shrine.CardContent[] => {
    const payload: any = response?.data
    const list: Shrine.CardContent[] =
        payload?.card_contents ??
        payload?.data?.card_contents ??
        payload?.data?.data?.card_contents ??
        payload?.data ??
        []

    return Array.isArray(list) ? list : []
}

export type StoreOption = {
    id: string
    title: string
    service_type?: string
}

export const transformStoreListResponse = (
    response: any,
    expectedServiceType: string | null,
): StoreOption[] => {
    const list: any[] = response?.data?.data?.store_list ?? []
    const normalized: StoreOption[] = (Array.isArray(list) ? list : [])
        .filter((s) => s && s.service_type === expectedServiceType)
        .map((s) => ({
            id: String(s.id),
            title: String(s.title || s.display_title || s.slug || s.id),
            service_type: s.service_type,
        }))

    return normalized
}

export const transformRecommendationsResponse = (response: any, cardId: string): string[] => {
    const payload: any = response?.data

    const maybeData: any =
        payload?.data ??
        payload?.data?.data ??
        payload?.data?.data?.data ??
        payload

    if (Array.isArray(maybeData)) {
        const record = maybeData.find((r) => r?.card_id === cardId) ?? maybeData[0]
        return Array.isArray(record?.entity_ids) ? record.entity_ids : []
    } else if (maybeData && typeof maybeData === 'object') {
        return Array.isArray(maybeData?.entity_ids) ? maybeData.entity_ids : []
    }

    return []
}

/**
 * Checks if the card type is a recommendation card
 * @param cardType - The type of the card
 * @returns true if card is a recommendation card (puja or chadhava)
 */
export const isRecommendationCard = (cardType?: string): boolean => {
    return cardType === CARD_TYPES.RECOMMEND_PUJA || cardType === CARD_TYPES.RECOMMEND_CHADHAVA
}

/**
 * Gets the expected store service type based on card type
 * @param cardType - The type of the card
 * @returns 'pooja' for puja cards, 'offerings' for chadhava cards, null otherwise
 */
export const getStoreServiceType = (cardType?: string): string | null => {
    if (cardType === CARD_TYPES.RECOMMEND_PUJA) return 'pooja'
    if (cardType === CARD_TYPES.RECOMMEND_CHADHAVA) return 'offerings'
    return null
}
